module.exports = __webpack_public_path__ + "img/sign_260790952_1.4336812e.png";